<app-simple-modal [title]="'Crear Empresa Asociada'" (close)="close.emit($event)">
	<div fields>
		<h5>Datos de Empresa</h5>
		<div class="row">
			<div class="col">
				<div class="row">
					<div class="col form-group">
						<label for="companyNit" class="form-label">NIT <ng-container
								*ngTemplateOutlet="require"></ng-container>
						</label>
						<div class="input-group">
							<app-input-autocomplete [filterElements]="inputNit.filterElements" [allBorderRadius]="true"
								[inputs]="inputNit" (inputMethod)="writeNit()"
								(changeStatus)="selectNit($event.filterElement)"
								(getTitle)="$event.filterElement.title = $event.filterElement.nit"
								[placeholder]="'Ingresa el nit o selecciona'">
							</app-input-autocomplete>
						</div>
					</div>
					<div class="col form-group">
						<label for="companyTaxRegime" class="form-label">Régimen de Impuestos <ng-container
								*ngTemplateOutlet="require"></ng-container>
						</label>
						<select id="companyTaxRegime" [(ngModel)]="newCompany.companyTaxRegime" name="companyTaxRegime"
							class="form-select">
							<option value="1">Pequeño Contribuyente</option>
							<option value="2">Mensual</option>
							<option value="3">Trimestral</option>
						</select>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="row">
					<div class="col form-group">
						<label for="activity" class="form-label">Actividad Economica <ng-container
								*ngTemplateOutlet="require"></ng-container> </label>
						<div class="input-group">
							<app-input-autocomplete [filterElements]="inputActivity.filterElements"
								[allBorderRadius]="true" [inputs]="inputActivity" (inputMethod)="write()"
								(changeStatus)="select($event.filterElement)"
								(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' +  $event.filterElement.name"
								[placeholder]="'Ingresa el código o el nombre de la actividad, luego selecciona'">
							</app-input-autocomplete>
						</div>
						<p class="form-text"><i class="fa fa-circle-info"></i>Debes ingresar mínimo 1 y máximo 3</p>
					</div>
					<div class="col" *ngIf="newCompany.companyActivities.length > 0">
						<ul>
							<li *ngFor="let activity of newCompany.companyActivities; let i = index">
								{{collectionActivities[activity].code + " " + collectionActivities[activity].name}}
								<i class="clickeable fa fa-trash text-danger"
									(click)="newCompany.companyActivities.splice(i,1)"></i>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group">
			<label for="companyName" class="form-label">Nombre <ng-container *ngTemplateOutlet="require"></ng-container>
			</label>
			<input type="text" id="companyName" [(ngModel)]="newCompany.companyName" placeholder="Ingresa el nombre"
				name="companyName" class="form-control">
		</div>
		<h5 class="mt-3">Datos de Administrador</h5>
		<div class="row">
			<div class="col form-group">
				<label for="contactName" class="form-label">Nombre <ng-container
						*ngTemplateOutlet="require"></ng-container>
				</label>
				<input type="text" id="contactName" [(ngModel)]="newCompany.contactName"
					placeholder="Ingresa el nombre del administrador" name="contactName" class="form-control">
			</div>
			<div class="col form-group">
				<label for="contactEmail" class="form-label">Correo <ng-container
						*ngTemplateOutlet="require"></ng-container>
				</label>
				<input type="text" id="contactEmail" [(ngModel)]="newCompany.contactEmail"
					placeholder="Ingresa el correo del administrador" name="contactEmail" class="form-control">
			</div>
			<div class="col form-group">
				<label for="contactPhone" class="form-label">Teléfono</label>
				<input type="text" id="contactPhone" [(ngModel)]="newCompany.contactPhone"
					placeholder="Ingresa el teléfono del administrador" name="contactPhone" class="form-control">
			</div>
		</div>
	</div>
	<div buttons>
		<app-loading-button [object]="buttonSave" (clicked)="saveAssociate()" [disabled]="!newCompany.companyNit || !newCompany.companyName ||
		!newCompany.companyTaxRegime || newCompany.companyActivities.length == 0 || !newCompany.contactEmail
		|| !newCompany.contactName || loading"></app-loading-button>
	</div>
</app-simple-modal>
<ng-template #require>
	<span [tooltip]="'Campo requerido'" class="fa fa-asterisk text-danger"></span>
</ng-template>